import { Navbar, HeroSlider, Footer, Offers, Catog } from '../Components/index';
const HomePage = () => {
	return (
		<div>
			<Navbar />
			<HeroSlider />
			<Offers />
			<Catog />
			<Footer />
		</div>
	);
};
export default HomePage;
